<!--<app-sidebar2></app-sidebar2>-->
<div class="content-wrapper" style="min-height: 307px">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="triangle-skew-spin" [fullScreen]="false">
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="container-fluid">
        <mat-form-field appearance="fill">
            <mat-label>Search and Select</mat-label>
            <input matInput placeholder="Search" [(ngModel)]="searchTerm" (ngModelChange)="filterOptions()">
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Select an item</mat-label>
            <mat-select>
                <mat-option *ngFor="let item of filteredItems" [value]="item">
                    {{ item.dscription }} - {{ item.quantity }} units, Total: {{ item.linetotalafvat | currency }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>เลือกวันที่</mat-label>
            <input matInput [matDatepicker]="picker" (dateChange)="onDateChange($event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>


        <h3>year:{{year}}</h3>
        <div class="row">
            <div class="col-md-5">
                <section>
                    <div class="example-label">editDATA_from_JSON</div>
                    <div class="example-button-row">
                        <button mat-raised-button color="primary" (click)=" getprofile()">DATA_profile</button>
                    </div>
                    <div class="example-label">length : {{profileA.length|number}}</div>
                    <p>{{percent|number :'1.2-2'}} %, เริ่มต้น-{{num_se.start|number}}, ตอนนี้-{{num_se.now|number}},
                        จาก-{{num_se.end|number}}</p>
                    <div class="example-button-row">
                        <button mat-raised-button color="primary" *ngIf="profileA.length>0"
                            (click)="exportAsXLSX(profileA,'DATA_profile')">load_DATA_profile</button>
                        <button mat-raised-button color="accent" *ngIf="profileA.length>0 && Edata.length>0"
                            (click)="edit_sup_data()">edit_Edata: {{ Edata.length }}</button>
                        <button mat-raised-button color="accent" *ngIf="Edata2.length>0"
                            (click)="edit_data()">edit_Edata2_0: {{ Edata3.length }}</button>
                        <button mat-raised-button color="accent" *ngIf="maps.length>0 && Edata2.length>0"
                            (click)="edit_data2()">edit_Edata2_1: {{ Edata2.length }}</button>
                    </div>
                </section>
                <hr>
                <br>
                <section>
                    <div class="example-label">DATA_CP</div>
                    <div class="example-button-row">
                        <button mat-raised-button color="primary" (click)="getdataCP()">DATA_CP</button>
                    </div>
                    <div class="example-label">length : {{data.length|number}}</div>
                    <div class="example-button-row">
                        <button mat-raised-button color="primary" *ngIf="data.length>0"
                            (click)="exportAsXLSX(data,'DATA_sql')">load_DATA_sql</button>
                    </div>
                </section>
                <hr>
                <br>
                <mat-divider></mat-divider>
                <section>
                    <div class="example-label">DATA_firebase</div>
                    <div class="example-button-row">
                        <button mat-raised-button color="accent" (click)="getMapall()">DATA_firebase</button>
                    </div>
                    <div class="example-label">length : {{maps.length|number}}</div>
                    <div class="example-button-row">
                        <button mat-raised-button color="primary" *ngIf="maps.length>0"
                            (click)="exportAsXLSX(maps,'DATA_firebase')">load_DATA_firebase</button>
                    </div>
                </section>
                <hr>
                <mat-divider></mat-divider>
                <section>
                    <div class="example-label">Map_cut_from_firebase</div>
                    <div class="example-button-row">
                        <button mat-raised-button color="accent" (click)="getMap_cut()">Map_cut_firebase</button>
                    </div>
                    <div class="example-label">length : {{maps_cut.length|number}}</div>
                    <div class="example-button-row">
                        <button mat-raised-button color="primary" *ngIf="maps_cut.length>0"
                            (click)="exportAsXLSX(maps_cut,'DATA_firebase')">load_DATA_cut_firebase</button>
                    </div>
                    <div class="example-button-row">
                        <button mat-raised-button color="accent" *ngIf="maps_cut.length>0"
                            (click)="updatecut_firebae()">update_cut_firebase</button>
                    </div>
                </section>
                <hr>
                <br>
                <mat-divider></mat-divider>
                <section>
                    <div class="example-label">DATA_action</div>
                    <div class="example-button-row">
                        <button mat-raised-button color="warn" [disabled]="maps.length==0||data.length==0"
                            (click)="updatefirebase()">ตกลง</button>
                    </div>
                    <div class="example-label">percent : {{percent|number :'1.2-2'}} %</div>

                </section>
                <mat-divider></mat-divider>
                <section>
                    <button mat-raised-button color="warn" (click)="get_data_p()">get data P</button>
                </section>
            </div>
            <div class="col-md-7">
                <div class="example-label">noHave : {{noHave.length}}</div>
                <table class="table table-bordered table-sm">
                    <thead>
                        <tr style="text-align:center">
                            <th style="width:25%">.</th>
                            <th style="width:30%">itid</th>
                            <th style="width:30%">val</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="text-align:center" *ngFor="let dt of noHave; index as i;">
                            <td> {{i+1}}</td>
                            <td> {{dt.itid}}</td>
                            <td>{{dt.groupCode}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <hr>

        <div class="row">
            <div class="col-md-4">
                <mat-form-field class="example-form-field" appearance="fill">
                    <mat-label>input itid</mat-label>
                    <input matInput type="text" [(ngModel)]="itid">
                    <button *ngIf="itid" matSuffix mat-icon-button aria-label="Clear" (click)="itid=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="col-md-2" *ngIf="itid.length>0">
                <button mat-raised-button color="warn" (click)="loadkey()">ตกลง</button>
            </div>
            <pre>{{dataKey | json}}</pre>
        </div>
        <br>
        <div class="row">
            <div class="col-md-4">
                <div class="col-md-2">
                    <button mat-raised-button color="warn" (click)="loadgetmapby1()">ตกลง-mapby1</button>
                </div>
            </div>
            <div class="col-md-4 card" style="text-align:center">
                <div id="for_echarts" style="align-items: center; width: 100%; height:400px;">
                </div>
            </div>
        </div>
    </div>

    <!-- Tab panes -->
    <div class="accordion" id="accordionExample">
        <div id="headingOne">
            <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne"
                aria-expanded="true" aria-controls="collapseOne">
                Collapsible Group Item #1
            </button>
        </div>
        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
            labore sustainable VHS.
        </div>

    </div>

    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>Redial</span>
        </button>
        <button mat-menu-item disabled>
            <mat-icon>voicemail</mat-icon>
            <span>Check voice mail</span>
        </button>
        <button mat-menu-item>
            <mat-icon>notifications_off</mat-icon>
            <span>Disable alerts</span>
        </button>
    </mat-menu>

    <li class="nav-item">
        <a [ngClass]="{'nav-link': true}" [matMenuTriggerFor]="menu">
            &nbsp; <i class="far fa-address-book nav-icon"></i>
            <p>ปี 67/68 <i class="fas fa-angle-left right"></i></p>
        </a>
        <mat-menu #menu="matMenu">
            <button mat-menu-item [routerLink]="['/myprofile']"> <span>แก้ไขข้อมูลส่วนตัว</span>
            </button>
            <button mat-menu-item [routerLink]="['/myprofile']"> <span>ออกจากระบบ</span>
            </button>
        </mat-menu>
    </li>

    <li class="nav-item">
        <div [matMenuTriggerFor]="menu0" class="d-flex flex-row d-flex align-items-center">
            <div class="flex justify-center items-center">
                <span style="color: black;"> --- : --- </span>
                <mat-icon>keyboard_arrow_down</mat-icon>
            </div>
        </div>
        <!--<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon> </button>-->
        <mat-menu #menu0="matMenu">
            <button mat-menu-item [routerLink]="['/myprofile']">
                <mat-icon>settings</mat-icon>
                <span>แก้ไขข้อมูลส่วนตัว</span>
            </button>
            <button mat-menu-item>
                <mat-icon style="color: red;">logout</mat-icon>
                <span>ออกจากระบบ</span>
            </button>
        </mat-menu>
    </li>


</div>